import { Task } from 'views/pages/MyTasks/TaskDetail/types'
import { useTranslation } from 'react-i18next'
import { Progress, Spinner } from '@agro-club/agroclub-shared'
import { ARouterLink } from 'views/components/Analytics'
import { generatePath } from 'react-router'
import { refetchFunc, useSingleEntity } from 'modules/domain/common/hooks'
import { Card } from 'views/components/Card/Card'
import { InfoBlock } from '../../styled'
import { endpoints } from 'modules/endpoints'
import { SampleWithRequests } from 'views/pages/Samples/types'
import { ExportBotWrapper } from 'views/pages/Samples/SampleDetail/ExportBotWrapper'
import BidRoutes from 'views/pages/Bid/routes'
import SamplesRoutes from 'views/pages/Samples/routes'
import { useAProgress } from 'hooks/useAProgress'
import { apiClient } from 'modules/utils/httpClient'
import { useNotification } from 'hooks/useNotification'

interface Props {
  task: Task
  taskRefetch: refetchFunc
}

export const SendBidToExportBot = ({ task, taskRefetch }: Props) => {
  const { t } = useTranslation('my_tasks')
  const [, samples, samplesRefetch] = useSingleEntity<SampleWithRequests[]>(
    endpoints.samplesForBid(task.linked_bid!.id),
  )
  const notify = useNotification()

  const [, completeTask] = useAProgress(() => apiClient.post(endpoints.completeTask(task.id.toString())), {
    eventName: 'complete',
    analyticsPayload: {
      id: task.id.toString(),
    },
    onSuccess: () => {
      taskRefetch()
      notify(Progress.SUCCESS, { title: t('table.completed_task') })
    },
  })

  if (!samples || !task.linked_bid) {
    return <Spinner />
  }
  const onSuccess = async () => {
    await Promise.all([completeTask(), taskRefetch(), samplesRefetch()])
  }

  const latest_sample = samples[0]
  if (!latest_sample) return <div> {t('noSampleFound')}</div>

  const bidLink = (
    <ARouterLink
      eventName="bid"
      itemId={String(task.linked_bid.id)}
      to={generatePath(BidRoutes.Details, { id: task.linked_bid.id })}
    >
      {`${t('detail.bid_id')} ${task.linked_bid.id}`}
    </ARouterLink>
  )
  let content
  if (!latest_sample.can_be_send_to_export_bot) {
    content = (
      <div>
        {bidLink} {t('detail.sampleCantBeSendText')}{' '}
        <ARouterLink
          eventName="bid"
          itemId={String(latest_sample.id)}
          to={generatePath(SamplesRoutes.Details, { id: latest_sample.id })}
        >
          {`${t('detail.sample_id')} ${latest_sample.id}`}
        </ARouterLink>{' '}
      </div>
    )
  } else {
    // used in ru only, no sense to use <Trans/>  here
    content = (
      <>
        <div>
          Если {bidLink} все еще актуальна, отправьте ее повторно в экспортый чат{' '}
          <ExportBotWrapper sample={latest_sample} onSucess={onSuccess} />
        </div>
        <div>Либо перейдите в {bidLink} и архивируйте ее</div>
      </>
    )
  }

  return (
    <Card.Container>
      <Card.GapableContent>
        <Card.Title>{t('detail.description')}</Card.Title>
        <InfoBlock>{content}</InfoBlock>
      </Card.GapableContent>
    </Card.Container>
  )
}
